<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col sm="12">
          <b-card>
            <div slot="header"><i class='fa fa-align-justify'></i> 查看标签</div>
            <b-form-group label="" label-for="elementsAppendButton">
              <b-input-group>
                <!-- Attach Left button -->
                <b-input-group-prepend>
                  <b-dropdown text="操作" variant="success">
                    <b-dropdown-item @click="clickAdd()" v-if="hasEditRole">新增</b-dropdown-item>
                    <b-dropdown-item @click="clickUpdateVersion()" v-if="hasEditRole">升级</b-dropdown-item>
                    <b-dropdown-item href="http://artifactory.sf-express.com/artifactory/npm-third-file/TIB_js-studiocomm_6.9.0_windows_x86_64.exe">下载工具</b-dropdown-item>
                    <!-- <b-dropdown-item href="/sample.zip">下载样式</b-dropdown-item> -->
                    <b-dropdown-item @click="clickGetFields()">我的参数</b-dropdown-item>
                  </b-dropdown>
                </b-input-group-prepend>
                <b-form-input v-model="options.query.id" placeholder="编号"></b-form-input>
                <b-form-input v-model="options.query.name" placeholder="名称"></b-form-input>
                <b-form-select v-model="options.query.labelType"
                  :plain="true"
                  :options="['所有类型','客户打印面单','顺丰打印面单', '客户和顺丰共用面单', '顺丰包牌','代理包牌','拣货单','拣货单US']">
                </b-form-select>
                <b-form-input v-model="options.query.directionCode" placeholder="流向"></b-form-input>
                <b-form-input v-model="options.query.expressType" placeholder="产品"></b-form-input>
                <b-form-input v-model="options.query.agentCode" placeholder="代理"></b-form-input>
                <b-form-input v-model="options.query.destCountry" placeholder="国家"></b-form-input>
                <b-input-group-append>
                  <b-button variant="primary" @click="clickSearch()"><i class="fa fa-search"></i></b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <v-server-table ref="table" :url="backendUrl + '/label/preview/get'" :columns="columns" :options="options" @error="errorLoadingTableData">
              <b-button-group slot="operation" slot-scope="props" v-if="hasEditRole">
                <b-button variant="success" @click="clickEdit(props.row.id)"><i class='fa fa-pencil'></i></b-button>
                <b-button variant="danger" @click="clickDelete(props.row.id)"><i class='fa fa-trash'></i></b-button>
              </b-button-group>
              <b-button slot="directionCode" slot-scope="props" variant="primary" @click="clickDirectionCode(props.row.id)"><i class="fa fa-eye"></i></b-button>
              <c-switch v-model="props.row.fromAgent" slot="fromAgent" slot-scope="props" size="lg" class="mx-1" color="primary" variant="pill" label v-bind="labelTxt" disabled />
              <b-button v-if="props.row.xmlFile" slot="xmlFile" slot-scope="props" variant="primary" @click="clickXmlFile(props.row.id)"><i class="fa fa-eye"></i></b-button>
              <b-button v-if="props.row.jasperFile" slot="jasperFile" slot-scope="props" variant="primary" v-bind:href="backendUrl + '/label/preview/getJasperFile/' + props.row.id + '?username=' + username" target='_blank'><i class="fa fa-eye"></i></b-button>
            </v-server-table>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <b-modal :title="addTitle" v-model="addModal" @ok="clickConfirmAdd" modal-class="modal-success" ok-variant="success" ok-title='提交' cancel-title='取消'>
      <b-form>
        <b-form-group label="名称" label-for="name">
          <b-form-input
            id="name"
            v-model="$v.form.name.$model"
            :state="$v.form.name.$dirty ? !$v.form.name.$error : null"
            aria-describedby="name-feedback">
          </b-form-input>
          <b-form-invalid-feedback id="name-feedback">
            不能为空
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          label="类型"
          label-for="labelType"
          >
          <b-form-select id="labelType" v-model="form.labelType"
            :plain="true"
            :options="['客户打印面单','顺丰打印面单', '客户和顺丰共用面单', '顺丰包牌','代理包牌','拣货单','拣货单US']">
          </b-form-select>
        </b-form-group>
        <b-form-group
          label="流向"
          label-for="directionCode"
          >
          <b-form-textarea id="directionCode" v-model="form.directionCode" :rows="3"></b-form-textarea>
        </b-form-group>
        <b-form-group label="尺寸" label-for="printSize">
          <b-form-input id="printSize" v-model="form.printSize"></b-form-input>
        </b-form-group>
        <b-form-group
          label="源码"
          label-for="xmlFile"
          >
          <b-form-textarea
            id="xmlFile"
            :rows="3"
            v-model="$v.form.xmlFile.$model"
            :state="$v.form.xmlFile.$dirty ? !$v.form.xmlFile.$error : null"
            :disabled="form.fromAgent"
            aria-describedby="name-feedback">
          </b-form-textarea>
          <b-form-invalid-feedback id="xmlFile-feedback">
            不能为空
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group>
          <b-form-checkbox v-model="form.fromAgent">是否请求代理接口</b-form-checkbox>
        </b-form-group>
      </b-form>
    </b-modal>
    <b-modal title="删除" size="sm" v-model="deleteModal" @ok="clickConfirmDelete()" modal-class="modal-danger" ok-variant="danger" ok-title='提交' cancel-title='取消'>
      <div>确认删除标签 {{ deleteId }} ？</div>
    </b-modal>
    <b-modal title="我的参数" scrollable v-model="fieldsModal" @ok="clickSaveFields()" modal-class="modal-success" ok-variant="success" ok-title='保存' cancel-title='取消'>
      <b-form>
        <b-form-group v-for="field in fields" :key="field.key" :label="field.key">
          <b-form-input v-model="field.value"></b-form-input>
        </b-form-group>
      </b-form>
    </b-modal>
    <b-modal title="流向代码" size="sm" v-model="directionCodeModal" @ok="directionCodeModal = false" modal-class="modal-primary" ok-only>
      <div class="d-block text-center">
        <b-form-textarea v-model="directionCode" :rows="9"></b-form-textarea>
      </div>
    </b-modal>
    <b-modal title="源码" size="lg" v-model="xmlFileModal" @ok="xmlFileModal = false" modal-class="modal-primary" ok-only>
      <div class="d-block text-center">
        <b-form-textarea v-model="xmlFile" :rows="9"></b-form-textarea>
      </div>
    </b-modal>
    <b-modal :title="errorTitle" class="modal-danger" v-model="errorModal" @ok="errorModal = false" modal-class="modal-danger" ok-variant="danger" ok-only>
      <p>{{ errorMessage }}</p>
    </b-modal>
    <b-modal title="提交成功" class="modal-danger" v-model="successModal" @ok="successModal = false" modal-class="modal-primary" ok-only>
      <p>已触发审核流程，请到《审核表》查看流程状态</p>
    </b-modal>
  </div>

</template>

<script>
import axios from 'axios'
import { Switch as cSwitch } from '@coreui/vue'
import { validationMixin } from 'vuelidate'
import { required, requiredIf } from 'vuelidate/lib/validators'

export default {
  mixins: [validationMixin],
  components: {
    cSwitch
  },
  data () {
    return {
      username: '', // 用户名
      hasEditRole: this.$root.userInfo.userType === 0 || this.$root.userInfo.permissions.includes('L001'), // 编辑标签
      fieldsModal: false,
      addModal: false,
      deleteModal: false,
      directionCodeModal: false,
      xmlFileModal: false,
      errorModal: false,
      successModal: false,
      id: '',
      expressType: '',
      agentCode: '',
      country: '',
      backendUrl: axios.backendUrl,
      columns: ['operation', 'id', 'version', 'name', 'printSize', 'labelType', 'directionCode', 'fromAgent', 'xmlFile', 'jasperFile'],
      options: {
        query: {
          id: '',
          name: '',
          labelType: '所有类型',
          directionCode: '',
          expressType: '',
          agentCode: '',
          destCountry: ''
        },
        requestAdapter(data) {
          data.id = this.query.id
          data.name = this.query.name
          data.labelType = this.query.labelType
          data.directionCode = this.query.directionCode
          data.expressType = this.query.expressType
          data.agentCode = this.query.agentCode
          data.destCountry = this.query.destCountry
          return data
        },
        filterable: false,
        perPage: 10,
        perPageValues: [10],
        headings: {
          operation: '操作',
          id: '编号',
          name: '名称',
          version: '版本',
          labelType: '类型',
          directionCode: '流向',
          fromAgent: '请求代理接口',
          printSize: '尺寸',
          xmlFile: '源码',
          jasperFile: '预览'
        }
      },
      fields: [],
      directionCode: null,
      xmlFile: null,
      errorTitle: null,
      errorMessage: null,
      deleteId: null,
      addTitle: null,
      form: {
        labelId: null,
        name: null,
        labelType: '客户打印面单',
        directionCode: null,
        fromAgent: false,
        printSize: null,
        xmlFile: null
      },
      labelTxt: {
        dataOn: '是',
        dataOff: '否'
      }
    }
  },
  validations: {
    form: {
      name: {
        required
      },
      xmlFile: {
        required: requiredIf((form) => {
          return form.fromAgent == false
        })
      }
    }
  },
  methods: {
    showError(error) {
      if (error.response) {
        this.errorTitle = error.response.data.error
        this.errorMessage = error.response.data.message
        this.errorModal = true
      } else {
        this.errorTitle = error.message
        this.errorMessage = '无法访问后端'
        this.errorModal = true
      }
    },
    errorLoadingTableData(error) {
      this.showError(error)
    },
    clickAdd() {
      this.addTitle = '新增'
      this.form.labelId = null
      this.form.name = null
      this.form.labelType = '客户打印面单'
      this.form.directionCode = null
      this.form.fromAgent = false
      this.form.printSize = '100*100'
      this.form.xmlFile = null
      this.$v.form.$reset()
      this.addModal = true
    },
    clickEdit(id) {
      axios.get(this.backendUrl + '/label/preview/getLabel/' + id).then(response => {
        this.addTitle = '编辑'
        this.form.labelId = id
        this.form.name = response.data.name
        this.form.labelType = response.data.labelType
        this.form.directionCode = response.data.directionCode
        this.form.fromAgent = response.data.fromAgent
        this.form.printSize = response.data.printSize
        this.form.xmlFile = response.data.xmlFile
        this.$v.form.$reset()
        this.addModal = true
      }).catch(error => {
        this.showError(error)
      })
    },
    clickConfirmAdd(bvModalEvt) {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        return
      }

      // Form submit logic
      axios.post(this.backendUrl + '/label/preview/add', this.form).then(response => {
        this.successModal = true
      }).catch(error => {
        this.showError(error)
      })
    },
    clickUpdateVersion() {
      axios.post(this.backendUrl + '/label/preview/updateVersion').then(response => {
        this.successModal = true
      }).catch(error => {
        this.showError(error)
      })
    },
    clickGetFields() {
      axios.get(this.backendUrl + '/label/preview/getFields').then(response => {
        this.fields = []
        for (var key of Object.keys(response.data)) {
          this.fields.push({key: key, value: response.data[key]})
        }
        this.fields.sort(function(a, b){
          return a.key.localeCompare(b.key)
        })
        this.fieldsModal = true
      }).catch(error => {
        this.showError(error)
      })
    },
    clickDelete(id) {
      this.deleteId = id
      this.deleteModal = true
    },
    clickConfirmDelete() {
      this.deleteModal = false
      axios.delete(this.backendUrl + '/label/preview/delete/' + this.deleteId).then(response => {
        this.successModal = true
      }).catch(error => {
        this.showError(error)
      })
    },
    clickSaveFields() {
      var myfields = {}
      for (var field of this.fields) {
        myfields[field.key] = field.value
      }
      // console.log(JSON.stringify(myfields))
      axios.post(this.backendUrl + '/label/preview/updateFields', myfields).then(response => {
        console.log(response.data)
      }).catch(error => {
        this.showError(error)
      })
    },
    clickDirectionCode(id) {
      axios.get(this.backendUrl + '/label/preview/getDirectionCode/' + id).then(response => {
        this.directionCode = response.data
        this.directionCodeModal = true
      }).catch(error => {
        this.showError(error)
      })
    },
    clickXmlFile(id) {
      axios.get(this.backendUrl + '/label/preview/getXmlFile/' + id).then(response => {
        this.xmlFile = response.data
        this.xmlFileModal = true
      }).catch(error => {
        this.showError(error)
      })
    },
    clickJasperFile(id) {
      axios.get(this.backendUrl + '/label/preview/getJasperFile/' + id, {responseType: 'blob'}).then(response => {
        var a = document.createElement('a')
        a.href = window.URL.createObjectURL(response.data)
        a.target = '_blank'
        a.click()
        a.remove()
      }).catch(error => {
        this.showError(error)
      })
    },
    clickSearch() {
      this.$refs.table.refresh()
    }
  }
}
</script>

<style>
  th, td:nth-child(odd), td:nth-child(even) {
    white-space: nowrap;
    text-align: center;
    vertical-align: middle;
  }
</style>
